export var TRACKER_AND_ETF_DEFINITION_KEY = 'trackerAndETFDefinition';
export var TRACKER_AND_ETF_SYNTHETIC_KEY = 'trackerAndETFSynthetic';
export var TRACKER_AND_ETF_SYNTHETIC_RISK_KEY = 'trackerAndETFSyntheticRisk';
export var TRACKER_AND_ETF_SALE_KEY = 'trackerAndETFSale';
export var TRACKER_AND_ETF_CURRENCY_RISK_KEY = 'trackerAndETFCurrencyRisk';
